<template>
  <VueStripePaymentElement
    :options="paymentElementOptions"
    @ready="onReady"
    @change="onChange"
    @loaderror="onLoadError"
  />
</template>

<script setup lang="ts">
import {
  usePaymentIntent,
  VueStripePaymentElement,
  type StripePaymentElement,
  type StripePaymentElementChangeEvent
} from '@vue-stripe/vue-stripe';
import type { StripeError, StripePaymentElementOptions } from '@stripe/stripe-js';

const props = defineProps<{
  clientSecret: string
}>();

const emit = defineEmits<{
  (event: 'ready'): void
  (event: 'change', complete: boolean): void
  (event: 'error', message: string): void
}>();

const { confirmPayment } = usePaymentIntent();
const paymentElementOptions: StripePaymentElementOptions = {
  fields: {
    billingDetails: {
      address: {
        country: 'never'
      }
    }
  }
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const onReady = (_element: StripePaymentElement) => {
  emit('ready');
};

const onChange = (event: StripePaymentElementChangeEvent) => {
  emit('change', event.complete);
};

const onLoadError = (event: { error: StripeError }) => {
  emit('error', event.error.message ?? 'Le formulaire de paiement est indisponible.');
};

const confirmPaymentIntent = () => {
  return confirmPayment({
    clientSecret: props.clientSecret,
    confirmParams: {
      return_url: window.location.href,
      payment_method_data: {
        billing_details: {
          address: {
            country: 'FR'
          }
        }
      }
    },
    redirect: 'if_required'
  });
};

defineExpose({ confirmPayment: confirmPaymentIntent });
</script>
